var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconDanger = function SvgIconDanger(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 11,
    viewBox: "0 0 13 11",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FB355D",
    d: "M6.708 1.527l4.12 7.237c.273.48.105 1.09-.375 1.364-.15.086-.32.131-.494.131h-8.24c-.551 0-1-.448-1-1 0-.173.046-.344.132-.495l4.12-7.237c.272-.48.883-.648 1.363-.375.156.09.285.219.374.375z",
    transform: "translate(-419.000000, -557.000000) translate(414.892715, 553.000000) translate(4.537941, 4.370517)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M6.274 6.894l.137-3.127c.013-.31-.226-.57-.535-.584h-.024c-.309 0-.559.25-.559.558v.025l.144 3.128c.01.224.195.4.419.4.224 0 .408-.176.418-.4zm-.427 2.203c.36 0 .663-.295.663-.663 0-.36-.303-.654-.663-.654-.376 0-.678.295-.678.654 0 .368.302.663.678.663z",
    transform: "translate(-419.000000, -557.000000) translate(414.892715, 553.000000) translate(4.537941, 4.370517)"
  })))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconDanger);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "icon-danger.a80719b025ccac6d54652b92c3ea7ee2.svg";